// removed by extract-text-webpack-plugin
module.exports = {"cell":"_1MT80Le2XP16f48dc6p1Hc"};


//////////////////
// WEBPACK FOOTER
// ./elements/Cell.scss
// module id = 1178
// module chunks = 0